const baseUrl = "https://osce.djmp.tw/"
module.exports = baseUrl;